module.exports = __webpack_public_path__ + "img/csr_swiper_06_mobile.fc9398da.jpg";